/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

/**
 * Protocol modes supported by MSAL.
 */
export enum ProtocolMode {
    AAD = "AAD",
    OIDC = "OIDC"
}
